import { NewsData } from "./model";
import pic1_1 from "./News1-1.png";
import pic2_1 from "./News2-1.png";
import pic2_2 from "./News2-2.png";
import YituLogo from "./YITU-logo.png";

export interface newsList {
  [name: string]: NewsData;
}

export const newsData: newsList = {
  "1": {
    title: "独行快，众行远｜依图携手战略合作伙伴，共同开创大模型新时代！",
    icon: YituLogo,
    date: "2024-6-21 18:00:00",
    contentStream: [
      {
        type: "paragraph",
        content: `随着“依图天问大模型4.0”的正式发布，我们一同开启了感知与认知融合的大模型时代新篇章。“依图天问大模型4.0”重新定义了智能安防领域的应用边界，在AI边界、工作范式、交付模式、工作角色等方面都带来了颠覆性的改变，不仅推动了安全防范到安全生产和智慧运营的应用场景跃迁，也开创了产品、营销、服务的新范式。与此同时，依图科技也正式拉开了大模型时代伙伴业务新范式的序幕。6月21日，依图众多战略合作伙伴走进依图，探讨大模型在不同领域的应用前景，共话未来，携手开创大模型新时代。`
      },
      
      { type: "blank", content: "40" },
      { type: "image", content: pic1_1 },
      { type: "blank", content: "40" },
      {
        type: "paragraph",
        content: `依图科技总裁段爱国率队欢迎各位远道而来的伙伴们，并以“万象更新 气象万千，携手开创大模型新时代”为主题，介绍了依图在合作伙伴业务的投入和决心。依图科技将以大模型开启通用AI之新时代，带着依图求索新十年的新气象，携手合作伙伴共同开创大模型的新征程，共同探索和迎接AI大模型的未来。`
      },
      { type: "blank", content: "24" },
      {
        type: "text-bold",
        content: "卓越产品，卓越能力"
      },
      {
        type: "paragraph",
        content: `依图天问大模型具有卓越的产品力。依托依图科技多年在人工智能领域的技术积累以及持续的产品研发能力、交付能力，依图天问大模型在语义交互、零样本生成及可训练性方面表现卓越，并在实际应用中展现出强大的实战性能和广泛的适用性。这将为合作伙伴业务的开展打下坚实的技术与产品基础。`
      },
      { type: "blank", content: "24" },
      {
        type: "text-bold",
        content: "全面赋能，共赴成长"
      },
      {
        type: "paragraph",
        content: `依图不仅注重技术创新，更注重技术的实际落地和应用。通过构建完善的赋能体系和支持体系，致力于帮助合作伙伴更好地理解和应用大模型技术，将用大模型的先进思想、理念和工具，全方位赋能合作伙伴，助力伙伴转型成为“场景大模型方案的提供商与运营商”，共同推动行业的数字化转型。通过行业落地实践，依图建立了全面的伙伴赋能体系，不仅提供领先的技术和产品，还将通过研、营、销、服全方位的支持，帮助合作伙伴成为大模型时代的同路人，共同成长和发展。`
      },
      { type: "blank", content: "24" },
      {
        type: "text-bold",
        content: "未来已来，携手共进"
      },
      {
        type: "paragraph",
        content: `依图两位合作伙伴现场分享了他们的实践心得，依图多模态大模型技术在智慧工地和智慧安全标准化班场景的实践落地，对客户痛点需求的精准匹配让他们看到了依图对行业深刻的理解以及技术产品的强大能力。`
      },
      { type: "blank", content: "24" },
      {
        type: "paragraph",
        content: `独行快，众行远！在大模型新时代，依图科技期待与更多的合作伙伴携手，共创、共赢大模型新时代，共同推进AI技术的广泛应用和产业升级。`
      }
    ],
    recommendations: [
      {
        cover: pic2_1,
        title: "志合越山海，聚力共前行｜依图多模态大模型伙伴CTO精研班圆满举办",
        id: "2"
      },
    ],
    previous: undefined,
    next: {
      title: "志合越山海，聚力共前行｜依图多模态大模型伙伴CTO精研班圆满举办",
      id: "2"
    }
  },
  "2": {
    title: "打造“依图+X”生态合作模式，依图开启AI合作伙伴招募",
    icon: YituLogo,
    date: "2024-7-20 12:00:00",
    contentStream: [
      {
        type: "paragraph",
        content: `依图科技多年来深耕人工智能领域，致力于将AI领先技术赋能各行业发展。随着依图天问大模型4.0的发布，依图也开启了大模型合作伙伴业务的新篇章。6月21日，来自全国各地的战略合作伙伴走进依图，共同探讨大模型在不同行业领域的应用前景；7月19日， “依图科技多模态大模型伙伴CTO精研班”在杭州圆满举办，让更多的伙伴们深度体验了依图多模态大模型产品，全面了解了依图多模态大模型技术及其场景化解决方案。`
      },
      { type: "blank", content: "40" },
      { type: "image", content: pic2_1 },
      { type: "blank", content: "40" },
      {
        type: "paragraph",
        content: `为了帮助合作伙伴更好地理解和应用大模型技术，助力伙伴转型成为“场景大模型方案的提供商与运营商”，共同推动行业的数字化转型，依图建立了全面的伙伴赋能体系，在提供领先的技术和产品的同时，还通过研、营、销、服为伙伴们提供全方位的支持，此次举办的精研班，也正是这一赋能体系的具体实践。`
      },
      { type: "blank", content: "24" },
      {
        type: "paragraph",
        content: `通过现场展示与实战操作体验，与会的CTO们不仅深入掌握了依图天问大模型产品的开箱即用配置、高效算法生成、以及灵活的训练迭代等交付流程，还深刻感受到天问大模型在自然语言理解、零样本创新算法生成、以及小样本快速训练迭代等方面的卓越能力与独特优势。通过精研班的深入交流，CTO们对依图多模态大模型技术的场景化解决方案有了更全面的认识，也为未来的合作与应用提供了宝贵的思路与灵感。`
      },
      { type: "blank", content: "40" },
      { type: "image", content: pic2_2 },
      { type: "blank", content: "40" },
      { 
        type: "paragraph",
        content: `依图科技坚信，通过与合作伙伴的精诚合作，可以共同推动大模型技术在更多实际场景中的落地应用，实现多方共赢。依图期待与更多的合作伙伴携手，共创、共赢大模型新时代，共同推进AI技术的广泛应用和产业升级，探索人工智能的无限可能。`
      },
    ],
    recommendations: [
      {
        cover: pic1_1,
        title: "独行快，众行远｜依图携手战略合作伙伴，共同开创大模型新时代！",
        id: "1"
      },
    ],
    previous: {
      title: "独行快，众行远｜依图携手战略合作伙伴，共同开创大模型新时代！",
      id: "1"
    },
    next: undefined
  },
};
